(function (Drupal, once) {
  Drupal.behaviors.heroVideoPoster = {
    attach: function (context, settings) {
      // Only process each hero video once
      once('hero-video', '[data-hero-video]', context).forEach(function(wrapper) {
        const poster = wrapper.querySelector('[data-video-poster]');
        const remoteVideo = wrapper.querySelector('.media--type-remote-video');

        if (poster && remoteVideo) {
          // Function to check for .video-play and hide poster
          const checkVideoPlay = () => {
            if (remoteVideo.classList.contains('video-play')) {
              poster.style.display = 'none';
            }
          };

          // Initial check in case the class is already applied
          checkVideoPlay();

          // Observe class changes on the remote video element
          const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
              if (mutation.attributeName === 'class') {
                checkVideoPlay();
              }
            });
          });

          observer.observe(remoteVideo, { attributes: true });
        }
      });
    }
  };
})(Drupal, once);
